import { Some, None } from "@siteimprove/alfa-option";
import { Refinement } from "@siteimprove/alfa-refinement";
const { isFunction, isObject } = Refinement;
/**
 * @public
 */
export var Serializable;
(function (Serializable) {
    function isSerializable(value) {
        return isObject(value) && isFunction(value.toSARIF);
    }
    Serializable.isSerializable = isSerializable;
    function toSARIF(value) {
        if (isSerializable(value)) {
            return Some.of(value.toSARIF());
        }
        return None;
    }
    Serializable.toSARIF = toSARIF;
})(Serializable || (Serializable = {}));
//# sourceMappingURL=serializable.js.map